var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubhouseOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48333 35.75C1.56667 35.75 0 37.3167 0 39.2333C0 41.15 1.56667 42.7167 3.48333 42.7167C5.4 42.7167 6.96667 41.15 6.96667 39.2333C6.96667 37.3167 5.41667 35.75 3.48333 35.75Z",
    fill: "#6515DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3667 5.33331L24.4333 12.3333V5.41665L0.783325 12.9666V33.0166L21.1833 26.5V33.3833L48 24.8333L40.7333 17.7333L46.3667 5.33331ZM21.1833 23.0666L4.04999 28.5333V15.35L21.1833 9.88331V23.0666ZM41.9333 23.35L24.4333 28.9333V15.7666L40.55 10.6166L36.85 18.4166L41.9333 23.35Z",
    fill: "#6515DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubhouseOriginal);
export default __webpack_public_path__ + "static/media/Clubhouse - Original.9e58f0979cb5a2cc5736897211de2683.svg";
export { ForwardRef as ReactComponent };